import { Component } from '@angular/core';
import { MetadatiService } from 'src/app/amministrazione/components/metadati/metadati/service/metadati.service';
import { Metadata, MetadataExt } from 'src/app/common/models/metadati/metadata';
import { DialogConfig } from 'src/app/core/components/dialog/dialog-config';
import { ItemOrder } from 'src/app/lem/models/common/item-order';

@Component({
  selector: 'app-modal-metadata-add',
  templateUrl: './modal-metadata-add.component.html',
  styleUrls: ['./modal-metadata-add.component.css']
})
export class ModalMetadataAddComponent {

  tipoPratica : string;

  metadataAssociated: ItemOrder<Metadata>[];

  metadata: Metadata[];

  metadataSelected: MetadataExt[] = [];

  constructor(private dialogConfig: DialogConfig, private metadatiService: MetadatiService){}

  ngOnInit(){
    this.tipoPratica = JSON.parse(this.dialogConfig.data.typePractice);
    console.log(this.tipoPratica);
  }


}
